import {
  InputOTP,
  InputOTPGroup,
  InputOTPSeparator,
  InputOTPSlot,
} from "@components/ui/input-otp";
import { REGEXP_ONLY_DIGITS } from "input-otp";

export interface OtpDigitsProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

/**
 * Six-digit verification-code entry rendered as two joined groups of three.
 * The underlying single input preserves paste, autofill, and screen-reader
 * behavior while the slots provide the Storydoc visual treatment.
 */
export const OtpDigits = ({
  value,
  onChange,
  disabled,
}: OtpDigitsProps) => (
  <InputOTP
    maxLength={6}
    pattern={REGEXP_ONLY_DIGITS}
    inputMode="numeric"
    autoComplete="one-time-code"
    value={value}
    onChange={onChange}
    disabled={disabled}
    autoFocus
  >
    <InputOTPGroup>
      <InputOTPSlot index={0} />
      <InputOTPSlot index={1} />
      <InputOTPSlot index={2} />
    </InputOTPGroup>
    <InputOTPSeparator />
    <InputOTPGroup>
      <InputOTPSlot index={3} />
      <InputOTPSlot index={4} />
      <InputOTPSlot index={5} />
    </InputOTPGroup>
  </InputOTP>
);
